const TEXT = {
    ERROR: {
        CODE_NOT_REGISTRATED: (code: string) => `Verdikoden ${code} var ikke registrert.`,
        EXPIRED: "Denne verdikoden er gått ut på dato",
        VOUCHER_AMOUNT_IS_ZERO: "Verdikoden er allerede brukt opp",
        VOUCHER_ALREADY_ADDED: "Verdikoden er allerede lagt inn",
        INVALID: "Denne verdikoden er ikke gyldig",
        VOUCHER_TOO_MANY_ATTEMPTS: "Du har forsøkt for mange ganger",
        VOUCHER_CODE_ERROR: "Feil med inntastet verdikode",
        VOUCHER_CREATED: "Verdikoden er ikke klar til bruk enda",
        VOUCHER_INACTIVE: "Verdikoden har gått ut på dato eller er deaktivert",
        VOUCHER_MISSING: "Du har ikke lagt inn en verdikode enda",
        VOUCHER_DEFAULT_ERROR: "En feil har oppstått.",
        DISCOUNT_ALREADY_USED: "Rabattkoden er allerede brukt",
        NOT_FOUND: "Verdikoden ble ikke funnet",
        GENERAL_ERROR: "En feil har oppstått ved sjekk av verdikoden",
        VOUCHER_CODE_ADDED_BUT_NOT_IN_USE: "Det finnes ingen produkter i handlekurven hvor rabattkoden er gjeldende.",
    },
    TABLE: {
        CAPTION: "Du har lagt inn følgende verdikoder",
        HEADER: {
            CODE: "Verdikode",
            REMAINING: "Restverdi",
            REMOVE: "Fjern",
        },
    },
    REGISTER: {
        INPUT_LABEL: "Verdikode",
        ADD: "Bruk kode",
    },
    CART: {
        LABEL: "Verdikode/gavekort",
    },
} as const;

export default TEXT;
